export default "__VITE_ASSET__DvlsouKb__"